let Base64Encode = function (str) {
    return window.btoa(unescape(encodeURIComponent(str)))
};
let Base64Decode = function (str) {
    return decodeURIComponent(escape(window.atob(str)))
};

let Base64ToArrayBuffer = function (base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}

let openNewBackgroundTab = function (url) {
    var a = document.createElement("a");
    a.href = url;
    var evt = document.createEvent("MouseEvents");
    evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, true, false, false, false, 0, null);
    document.body.appendChild(a);
    a.dispatchEvent(evt);
};
let ToPDF = function (base64doc, pdfname) {
    var arraybuf = Base64ToArrayBuffer(base64doc);
    var blob = new Blob([arraybuf]);
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = pdfname;
    link.click();
    if (navigator.userAgent.indexOf("Firefox") != -1) {

        window.open("data:application/pdf;base64, " + base64doc);

    } else {
        window.open("data:application/pdf;base64, " + base64doc).close();
    }

}

let getParamsByName = function (name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}
/**let ValidateEmail = function (email) {
    var re = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+/;
    if (email === "" || !re.test(email)) {
        return false;
    } else return true;
}**/

let ValidateEmail = function (mail) {
    if (/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return (true)
    }
    return (false)
}

let isDecimal = function (value) {
    return /^-?(?:0|0\.\d*|[1-9]\d*\.?\d*)$/.test(value)
}

let currencyFormat = function (value) {
    return new Intl.NumberFormat("es-MX", {
        style: "decimal",
        currency: "MXN",
        currencyDisplay: "symbol",
        useGrouping: true,
        minimumFractionDigits: 2
    }).format(Number(value));
};

let formatMoney = function (amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch {
        return "0.00";
    }
};

let dateNow = function () {
    let now = new Date();
    let year = "" + now.getFullYear();
    let month = "" + (now.getMonth() + 1);
    if (month.length == 1) {
        month = "0" + month;
    }
    let day = "" + now.getDate();
    if (day.length == 1) {
        day = "0" + day;
    }
    let hour = "" + now.getHours();
    if (hour.length == 1) {
        hour = "0" + hour;
    }
    let minute = "" + now.getMinutes();
    if (minute.length == 1) {
        minute = "0" + minute;
    }
    let second = "" + now.getSeconds();
    if (second.length == 1) {
        second = "0" + second;
    }
    return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}

let normalize = function (obj, key) {
    let resultado = '';
    try {
        resultado = obj[key];
        if (resultado === undefined) resultado = '';
        if (resultado === null) resultado = '';
    } catch {
        resultado = '';
    }
    return resultado;
}

let changeIfEmpty = function (value, new_value) {
    if (value === undefined || value === null || value === "") return new_value;
    return value;
};

let convertToCSV = function (objArray) {
    var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    var str = "";
    for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
            if (line != "") line += ",";
            line += array[i][index];
        }
        str += line.replace(/null/g, "") + "\r\n";
    }
    return str;
};
let exportCSVFile = function (headers, items, fileTitle) {
    if (headers) {
        items.unshift(headers);
    }
    var jsonObject = JSON.stringify(items);
    var csv = this.convertToCSV(jsonObject);
    var exportedFilenmae = fileTitle + ".csv" || "export.csv";
    var blob = new Blob([csv], {
        type: "text/csv;charset=utf-8;"
    });
    if (navigator.msSaveBlob) {
        //ie10
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        var link = document.createElement("a");
        link.setAttribute(
            "href",
            "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(csv)
        );
        link.setAttribute("download", exportedFilenmae);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

let ConvertToEmpty = function (valor) {
    if (valor === undefined) return " ";
    if (valor === null) return " ";
    if (valor === "") return " ";

    return valor.toString().replace(/,/g, "");
};

let ConvertToZero = function (valor) {
    if (valor === undefined) return 0;
    if (valor === null) return 0;
    if (valor === "") return 0;

    return valor;
};

let ToXML = function (base64doc, xmlname) {
    let xmlContent = Base64Decode(base64doc);
    let blob = new Blob([xmlContent], {
        type: 'text/xml'
    });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = xmlname;
    link.click();
    if (navigator.userAgent.indexOf("Firefox") != -1) {

        window.open(link);

    } else {
        window.open(link).close();
    }
    window.URL.revokeObjectURL(link);
};

let ToCSV = function (base64CSV, csvName) {
    let csvContent = Base64Decode(base64CSV);
    let blob = new Blob([csvContent], {
        type: 'text/csv'
    });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = csvName;
    link.click();
    if (navigator.userAgent.indexOf("Firefox") != -1) {

        window.open(link);

    } else {
        window.open(link).close();
    }
    window.URL.revokeObjectURL(link);
};

export default {
    Base64Encode,
    Base64Decode,
    ToPDF,
    ValidateEmail,
    isDecimal,
    currencyFormat,
    dateNow,
    getParamsByName,
    formatMoney,
    openNewBackgroundTab,
    normalize,
    changeIfEmpty,
    convertToCSV,
    exportCSVFile,
    ConvertToEmpty,
    ConvertToZero,
    ToXML,
    ToCSV
};